class Event {
    _id;
    _userId;
    _addressId;

    _photo;
    _thumbnail;
    _file;

    _title;
    _body;
    _date = {
        start: '',
        end: '',
    }
    _duration = {
        days: 0,
        hours: 0,
        minutes: 0
    };
    _capacity = 0;
    _participants = [];
    _locationType;
    _link;
    _items = [];
    _status = '';
    _timezone = '';

    _created;
    _modified;
    _translations;

    constructor(id, userId, addressId, thumbnail, file, title, body, capacity, locationType, created, modified, translations) {
        this._id = id;
        this._userId = userId;
        this._addressId = addressId;
        this._thumbnail = thumbnail;
        this._file = file;

        this._title = title;
        this._body = body;
        this._capacity = capacity;
        this._locationType = locationType;

        this._created = created;
        this._modified = modified;
        this._translations = translations;
    }

    setId(newId) {
        this._id = newId;
    }

    get id() {
        return this._id;
    }

    setUserId(newId) {
        this._userId = newId;
    }

    get userId() {
        return this._userId;
    }

    setAddressId(newId) {
        this._addressId = newId;
    }

    get addressId() {
        return this._addressId;
    }

    setThumbnail(thumbnail) {
        this._thumbnail = thumbnail;
    }

    get thumbnail() {
        return this._thumbnail;
    }

    setPhoto(photo) {
        this._photo = photo;
    }

    get photo() {
        return this._photo;
    }

    setFile(file) {
        this._file = file;
    }

    get file() {
        return this._file;
    }

    setTitle(newTitle) {
        this._title = newTitle;
    }

    get title() {
        return this._title;
    }

    setBody(newBody) {
        this._body = newBody;
    }

    get body() {
        return this._body;
    }

    setStartDate(newTimestamp) {
        this._date.start = newTimestamp;
    }

    setEndDate(newTimestamp) {
        this._date.end = newTimestamp;
    }

    get date() {
        return this._date;
    }

    setDuration(newDuration) {
        this._duration = newDuration;
    }

    setDurationIndividually(newDays, newHours, newMinutes) {
        this._duration.days = newDays;
        this._duration.hours = newHours;
        this._duration.minutes = newMinutes;
    }

    get duration() {
        return this._duration;
    }

    setCapacity(newCapacity) {
        this._capacity = newCapacity;
    }

    get capacity() {
        return this._capacity;
    }

    setParticipants(newParticipants) {
        this._participants = newParticipants;
    }

    pushParticipant(newParticipant) {
        this._participants.push(newParticipant);
    }

    get participants() {
        return this._participants;
    }

    setLocationType(newLocationType) {
        this._locationType = newLocationType;
    }

    get locationType() {
        return this._locationType;
    }

    setLink(newLink) {
        this._link = newLink;
    }

    get link() {
        return this._link;
    }

    setItems(items) {
        this._items = items;
    }

    pushItem(item) {
        this._items.push(item);
    }

    get items() {
        return this._items;
    }

    setStatus(status) {
        this._status = status;
    }

    get status() {
        return this._status;
    }

    setTimezone(timezone) {
        this._timezone = timezone;
    }

    get timezone() {
        return this._timezone;
    }

    setCreated(newTimestamp) {
        this._created = newTimestamp;
    }

    get created() {
        return this._created;
    }

    setModified(newModifiedDate) {
        this._modified = newModifiedDate;
    }

    get modified() {
        return this._modified;
    }

    setTranslations(newTranslations) {
        this._translations = newTranslations;
    }

    get translations() {
        return this._translations;
    }
}

class Participants {
    _id;
    _eventId;
    _eventItemId = [];

    _firstname;
    _lastname;
    _email;
    _role;

    _items = [];
    _code;
    _associations;
    _comments;

    _created;
    _modified;

    constructor(id, eventId, firstname, lastname, email, role, code, comments, created, modified) {
        this._id = id;
        this._eventId = eventId;
        this._firstname = firstname;
        this._lastname = lastname;
        this._email = email;
        this._role = role;
        this._code = code;
        this._comments = comments;
        this._created = created;
        this._modified = modified;
    }

    setId(newId) {
        this._id = newId;
    }

    get id() {
        return this._id;
    }

    setEventId(newEventId) {
        this._eventId = newEventId;
    }

    get eventId() {
        return this._eventId;
    }

    setEventItemId(newEventItemId) {
        this._eventItemId = newEventItemId;
    }

    pushEventItemId(newEventItemId) {
        this._eventItemId.push(newEventItemId);
    }

    get eventItemId() {
        return this._eventItemId;
    }

    setFirstname(newFirstname) {
        this._firstname = newFirstname;
    }

    get firstname() {
        return this._firstname;
    }

    setLastname(newLastname) {
        this._lastname = newLastname;
    }

    get lastname() {
        return this._lastname;
    }

    setEmail(newEmail) {
        this._email = newEmail;
    }

    get email() {
        return this._email;
    }

    setRole(newRole) {
        this._role = newRole;
    }

    get role() {
        return this._role;
    }

    setItems(newItems) {
        this._items = newItems;
    }

    pushItems(newItems) {
        this._items.push(newItems);
    }

    get items() {
        return this._items;
    }

    setCode(newCode) {
        this._code = newCode;
    }

    get code() {
        return this._code;
    }

    setAssociations(newAssociations) {
        this._associations = newAssociations;
    }

    get associations() {
        return this._associations;
    }

    setComments(newComments) {
        this._comments = newComments;
    }

    get comments() {
        return this._comments;
    }

    setCreated(newCreated) {
        this._created = newCreated;
    }

    get created() {
        return this._created;
    }

    setModified(newModified) {
        this._modified = newModified;
    }

    get modified() {
        return this._modified;
    }
}

class Item {
    _id;
    _eventId;

    _name;
    _quantity;
    _measurement;

    _created;
    _modified;

    constructor(id, eventId, name, quantity, measurement, created, modified) {
        this._id = id;
        this._eventId = eventId;
        this._name = name;
        this._quantity = quantity;
        this._measurement = measurement;
        this._created = created;
        this._modified = modified;
    }

    setId(newId) {
        this._id = newId;
    }

    get id() {
        return this._id;
    }

    setEventId(newEventId) {
        this._eventId = newEventId;
    }

    get eventId() {
        return this._eventId;
    }

    setName(newName) {
        this._name = newName;
    }

    get name() {
        return this._name;
    }

    setQuantity(newQuantity) {
        this._quantity = newQuantity;
    }

    get quantity() {
        return this._quantity;
    }

    setMeasurement(newMeasurement) {
        this._measurement = newMeasurement;
    }

    get measurement() {
        return this._measurement;
    }

    setCreated(newCreated) {
        this._created = newCreated;
    }

    get created() {
        return this._created;
    }

    setModified(newModified) {
        this._modified = newModified;
    }

    get modified() {
        return this._modified;
    }
}

export { Event, Participants, Item };
